import UserManagement from "../../../components/UserManagement";

const UserListPage = () => {
  return <UserManagement />;
};

export default UserListPage;
